import { asDefined, ifDefined, Listeners, Terminator, UUID } from "@opendaw/lib-std";
import { ModuleConnectionAdapter } from "./connection";
import { Pointers } from "@opendaw/studio-enums";
import { Modules } from "./module";
import { ModularDeviceBoxAdapter } from "../devices/audio-effects/ModularDeviceBoxAdapter";
export class ModularAdapter {
    #terminator = new Terminator();
    #listeners;
    #context;
    #box;
    #modules;
    #connections;
    constructor(context, box) {
        this.#context = context;
        this.#box = box;
        this.#listeners = this.#terminator.own(new Listeners());
        this.#modules = UUID.newSet(adapter => adapter.uuid);
        this.#connections = UUID.newSet(adapter => adapter.uuid);
        const addModule = (pointer) => {
            const adapter = Modules.adapterFor(this.#context.boxAdapters, pointer.box);
            const added = this.#modules.add(adapter);
            // assert(added, `Could not add ${pointer}`)
            // TODO Implement catchupAndSubscribeTransactual that deals with that situation
            if (!added) {
                return;
            }
            this.#listeners.proxy.onModuleAdded(adapter);
        };
        const removeModule = (pointer) => this.#listeners.proxy.onModuleRemoved(this.#modules.removeByKey(pointer.address.uuid));
        const addConnection = (pointer) => {
            const adapter = this.#context.boxAdapters.adapterFor(pointer.box, ModuleConnectionAdapter);
            const added = this.#connections.add(adapter);
            // assert(added, `Could not add ${pointer}`)
            // TODO Implement catchupAndSubscribeTransactual that deals with that situation
            if (!added) {
                return;
            }
            this.#listeners.proxy.onConnectionAdded(adapter);
        };
        const removeConnection = (pointer) => this.#listeners.proxy.onConnectionRemoved(this.#connections.removeByKey(pointer.address.uuid));
        this.#box.modules.pointerHub.filter(Pointers.ModuleCollection).forEach(addModule);
        this.#box.connections.pointerHub.filter(Pointers.ConnectionCollection).forEach(addConnection);
        this.#terminator.own(this.#box.modules.pointerHub
            .subscribe({ onAdded: addModule, onRemoved: removeModule }, Pointers.ModuleCollection));
        this.#terminator.own(this.#box.connections.pointerHub
            .subscribe({ onAdded: addConnection, onRemoved: removeConnection }, Pointers.ConnectionCollection));
    }
    catchupAndSubscribe(listener) {
        ifDefined(listener.onModuleAdded, fn => this.#modules.forEach(adapter => fn(adapter)));
        ifDefined(listener.onConnectionAdded, fn => this.#connections.forEach(adapter => fn(adapter)));
        return this.#listeners.subscribe(listener);
    }
    get box() { return this.#box; }
    get address() { return this.#box.address; }
    get uuid() { return this.#box.address.uuid; }
    get editingField() { return this.#box.editing; }
    get labelField() { return this.#box.label; }
    get modules() { return this.#modules.values(); }
    get connections() { return this.#connections.values(); }
    get device() {
        return this.#context.boxAdapters
            .adapterFor(asDefined(this.#box.device.pointerHub.incoming().at(0), "No device found").box, ModularDeviceBoxAdapter);
    }
    terminate() {
        console.debug(`terminate ${this}`);
        this.#terminator.terminate();
    }
}
